// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
import Icon from '@/common-utils/components/renders/icon/Icon';
import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';
// Common
import ICONS from '@/common-utils/enums/icons';
// Lang
import { nsSimCard } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.data
 * @returns {JSX} RenderSimUpdateTooltip
 */
function RenderSimUpdateTooltip({ data }) {

    return (
        <TooltipHelper
            trigger={<Icon icon={ICONS.SIM_CARDS_OFFER_PENDING} />}
            contentClass='max-w-xs whitespace-normal'
            content={
                data ?
                    <Entity entity={'next_iccid.pending'} namespace={nsSimCard} data={{ simData: data }} />
                    :
                    <Entity entity={'next_iccid.pending_no_display_name'} namespace={nsSimCard} />
            }
        />
    );
}

RenderSimUpdateTooltip.propTypes = {
    data: PropTypes.string.isRequired
};

export default RenderSimUpdateTooltip;